import type { DataSyncProcessedDto } from "../../../common/model/dataSyncProcessedDto";
import type { SyncStatus } from "../../../common/model/syncStatus";

export class DataSyncProcessed {
  constructor(
    public userId: string,
    public platformTimestamp: string,
    public serviceName: string,
    public correlationId: string,
    public highWaterMark: number,
    public started: Date,
    public status: SyncStatus,
    public updated?: Date,
    public finished?: Date,
    public error?: string,
  ) {}

  public isFinished(): boolean {
    return this.status === "FINISHED_SUCCESSFULLY" || this.status === "FINISHED_ON_ERROR";
  }

  static fromDto(dto: DataSyncProcessedDto): any {
    const {
      userId,
      platformTimestamp,
      serviceName,
      correlationId,
      highWaterMark,
      started,
      updated,
      finished,
      status,
      error,
    } = dto;
    return new DataSyncProcessed(
      userId,
      platformTimestamp,
      serviceName,
      correlationId,
      highWaterMark,
      started,
      status,
      updated,
      finished,
      error,
    );
  }
}
